//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";
import { DataSetAccessModel } from "./DataSetAccessModel";
import { SubmittingEntityModel } from "./SubmittingEntityModel";


export class DatabaseJobsModel extends ModelBase {
    static readonly $typeName = 'DatabaseJobsModel';
    public startDate: Date;
    public endDate: Date;
    public submittingEntityKey: string;
    public dataSets: DataSetAccessModel[];

}



// WEBPACK FOOTER //
// ./src/app/submission/models/DatabaseJobsModel.ts